<template>
  <div>
    <div v-html="recaptchaScript"></div>
    <vs-input
      v-validate="'required|email|min:3'"
      data-vv-validate-on="blur"
      name="email"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      label-placeholder="Email"
      v-model="email"
      class="w-full"
      @keydown.enter="checkToLogin" 
    />
    <span class="text-danger text-sm">
      {{ errors.first('email') }}
    </span>

    <div class="flex items-center">
      <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6|max:20'"
        :type="showPassword ? 'text' : 'password'"
        name="senha"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Senha"
        v-model="password"
        class="w-full mt-6"
        @keydown.enter="checkToLogin"
      />
      
      <span>
        <vs-icon
        :icon="showPassword ? 'visibility_off' : 'visibility'"
        class="absolute icon-grow"
        style="right:.9em; font-size:23px; cursor:pointer; user-select:none;"
        @click="showPassword = !showPassword"
        />
      </span>
    </div>

    <span class="text-danger text-sm">
      {{ errorPassword }}
    </span>
    <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Lembrar de Mim</vs-checkbox>
    </div>

    <div v-if="!isDevelopment" class="g-recaptcha" :data-sitekey="recaptchaKey"></div>

    <div class="flex flex-wrap justify-between my-5 mb-3">
      <vs-button 
        :disabled="!validateForm || buttonDisabled" 
        @click="checkReCaptcha"
        class="w-full"
      >
        Login
      </vs-button>

      <div class="mt-5">
        <a 
          v-if="isFuncional"
          class="w-full cursor-pointer text-inherit md:w-auto hover:text-primary"
          @click="redirectToSSO"
        >
          Entrar com a Funcional
        </a> <br>
        <a 
          class="w-full cursor-pointer text-inherit md:w-auto hover:text-primary"
          @click="redirectToForgot"
        >
        Parece que esqueci minha senha
      </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getCurrentTenant, getIp } from '@/utils';

export default {
  data() {
    return {
      email: '',
      password: '',
      token: '',
      errorPassword: '',
      checkbox_remember_me: false,
      recaptchaScript: '',
      recaptchaResponse: '',
      showPassword: false,
      verifyActivity: false,
      emailProcessed: false,
      expiration: null,
      buttonDisabled: false,

    }
  },
  mounted() {
    const code = this.$route.query.code;
    if (code) {
      this.loginSSO(code);
    }

    this.loadRecaptchaScript();
  },
  created() {
    const storedValue = localStorage.getItem('twoFactor');
    const parsedValue = storedValue === 'true';
    this.verifyActivity = parsedValue

    this.emailProcessed = this.$on('emailProcessed')
          this.expiration = localStorage.getItem('expiration');
          
          
          const email = localStorage.getItem('email');
          if (email && this.expiration === 'true') {
            this.redirectToForgot()
          }
  },
  computed: {
    isFuncional() {
      return process.env.VUE_APP_IS_FUNCIONAL === 'true'
    },
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.password !== '';
    },
    baseUrl() {
      return `${getBaseUrl()}${getCurrentTenant()}`;
    },
    isDevelopment() {
      return getBaseUrl().includes('localhost');
    },
    recaptchaKey() {
      return process.env.VUE_APP_RECAPTCHA_FRONT_API_SECRET_KEY;
    },
    recaptchaUrl() {
      return process.env.VUE_APP_RECAPTCHA_FRONT_API_URL + '?hl=pt-BR';
    },
    funcionalSSOBaseUrl() {
      return process.env.VUE_APP_FUNCIONAL_SSO_BASE_URL;
    },
    funcionalClientID() {
      return process.env.VUE_APP_FUNCIONAL_CLIENT_ID;
    },
    pedbotBaseUrl() {
      return process.env.VUE_APP_BASE_URL;
    }
  },
  methods: {
    checkReCaptcha(){
      if ( this.isDevelopment ) {
        this.recaptchaResponse = 'success';
        this.loginJWT();
        this.buttonDisabled = true;
      } else if ( grecaptcha.getResponse() ) {
        this.recaptchaResponse = grecaptcha.getResponse();
        this.loginJWT();
        this.buttonDisabled = true;
      } else {
        this.$vs.notify({title: 'ReCaptcha',
          text: 'Por favor, complete o reCAPTCHA antes de prosseguir.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning' })
      }
    },
    checkLogin() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      return true
    },
    async loginJWT() {
      if (!this.checkLogin()) {
        return;
      }
      localStorage.setItem('imageState', true)
        try {
          const ip = await getIp();
          const payload = {
            userDetails: {
              email: this.email,
              password: this.password
            },
            remember: this.checkbox_remember_me,
            recaptchaResponse: this.recaptchaResponse,
            ip: ip,
          }
          await this.$store.dispatch('auth/loginJWT', payload);
          setTimeout(() => {
            this.buttonDisabled = false;
          }, 1000);
        } catch (error) {
          this.buttonDisabled = false;
          this.errorPassword = error.message;
        }
    },
    redirectToTwoFactor() {
      this.$router.push({ name: 'two-factor' })
    },
    redirectToForgot() {
      this.$router.push({ name: 'forgot-password' })
    },
    checkToLogin() {
      if (this.password !== '' && this.email !== '') {
        this.checkReCaptcha()
      }
    },
    loadRecaptchaScript() {
      const script = document.createElement('script');
      script.src   = this.recaptchaUrl;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    },
    redirectToSSO() {
      const queryString = '&response_type=code&scope=id%20name%20email%20mobile_number%20uuid%20identity';
      const baseUrl = this.funcionalSSOBaseUrl + `/oauth2/authorize?client_id=${this.funcionalClientID}&redirect_uri=${this.pedbotBaseUrl}${getCurrentTenant()}/login${queryString}`;
      window.location.href = baseUrl;
    },
    async loginSSO(code) {
      this.buttonDisabled = true;
      if (!this.checkLogin()) {
        this.buttonDisabled = false;
        return;
      }

      try {
        const ip = await getIp();
        await this.$store.dispatch('auth/loginSSO', {
          ip: ip,
          code: code,
          redirectUri: this.pedbotBaseUrl + getCurrentTenant() + '/login'
        });
        setTimeout(() => this.buttonDisabled = false, 1000);
      } catch (error) {
        this.buttonDisabled = false;
      }
    }
  }
}

</script>

<style scoped>
  .icon-grow {
    transition: transform 0.3s ease;
  }

  .icon-grow:hover {
    transform: scale(1.2);
  }
</style>